import React, { Fragment } from "react";
import {
  PlusCircleIcon,
  XMarkIcon,
  CheckCircleIcon,
  XCircleIcon,
} from "@heroicons/react/24/outline";
import { Dialog, Transition } from "@headlessui/react";
import IconButton from "../../../iconButton";
import { formatDate, formatTime } from "../../../../utilities/utils";

const AdminActiveCreditSlideOver = ({
  show,
  setShowSlide,
  handleClose,
  type,
  creditData,
}) => {
  return (
    <Transition.Root show={show} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={handleClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-in-out duration-500"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in-out duration-500"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-hidden dashboard_calander_slideover">
          <div className="absolute inset-0 overflow-hidden">
            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full px-[15px] py-5 md:p-0">
              <Transition.Child
                as={Fragment}
                enter="transform transition ease-in-out duration-500 sm:duration-700"
                enterFrom="translate-x-full"
                enterTo="translate-x-0"
                leave="transform transition ease-in-out duration-500 sm:duration-700"
                leaveFrom="translate-x-0"
                leaveTo="translate-x-full"
              >
                <Dialog.Panel className="pointer-events-auto w-screen max-w-[478px]">
                  <div className="flex h-full flex-col bg-white py-5 md:pt-10 md:pb-5 px-4 md:px-8 shadow-xl rounded-md md:rounded-0">
                    <div className="">
                      <div className="border-b border-solid border-[#CCD0D4] pb-3 md:pb-[30px] mb-4 md:mb-6">
                        <div className="flex items-center justify-between">
                          <Dialog.Title className="text-xl md:text-2xl font-bold leading-[160%] text-[#04091E]">
                            Credit Request #{creditData?.id}
                          </Dialog.Title>
                          <XMarkIcon
                            className="w-6 h-6 cursor-pointer text-black hover:text-red-700"
                            onClick={handleClose}
                          />
                        </div>
                      </div>
                      {/* data section start */}
                      <div className="bg-white">
                        <div className="flex items-center justify-between pb-5 mb-[14px] border-b border-[#EBEFF3]">
                          <div className="flex items-center gap-1">
                            <span
                              className={`${
                                creditData?.status === "Denied"
                                  ? "bg-[#EF2121]"
                                  : "bg-[#16CA7C]"
                              } h-[27px] px-[10px] text-xs font-bold leading-[160%] text-white inline-flex items-center justify-center rounded-md`}
                            >
                              {creditData?.status}
                            </span>
                            {/* <span className="bg-[#D834A0] h-[27px] px-[10px] text-xs font-bold leading-[160%] text-white inline-flex items-center justify-center rounded-md">
                              {creditData?.status}
                            </span> */}
                          </div>
                          <div className="flex items-end flex-col">
                            <div className="flex items-center gap-[10px]">
                              <span className="text-sm font-normal leading-[140%] text-[#485868] hidden md:block">
                                Requested:
                              </span>
                              <span className="text-sm font-normal leading-[140%] text-[#485868]">
                                {formatDate(creditData?.created_at)}{" "}
                              </span>
                              <span className="text-[#485868] leading-[140%]">
                                &#8226;
                              </span>
                              <span className="text-sm font-normal leading-[140%] text-[#485868]">
                                {formatTime(creditData?.created_at)}
                              </span>
                            </div>
                            <div className="flex items-center gap-[10px]">
                              <span className="text-sm font-normal leading-[140%] text-[#485868] hidden md:block">
                                Closed:
                              </span>
                              <span className="text-sm font-normal leading-[140%] text-[#485868]">
                                {formatDate(creditData?.final_decision_at)}{" "}
                              </span>
                              <span className="text-[#485868] leading-[140%]">
                                &#8226;
                              </span>
                              <span className="text-sm font-normal leading-[140%] text-[#485868]">
                                {formatTime(creditData?.final_decision_at)}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div>
                          <div className="pb-[14px] mb-[14px] border-b border-[#EBEFF3]">
                            <h6 className="text-base font-bold leading-[160%] text-customGray mb-1">
                              Incorrect Contact
                            </h6>
                            <div className="flex items-center gap-[10px] mb-[14px]">
                              <span className="text-sm font-medium leading-[140%] text-primary">
                                {creditData?.reviewedMatch?.lead?.first_name}{" "}
                                {creditData?.reviewedMatch?.lead?.last_name}
                              </span>
                              <span className="text-[#485868] leading-[140%]">
                                &#8226;
                              </span>
                              <span className="text-sm font-normal leading-[140%] text-[#485868]">
                                {creditData?.reviewedMatch?.lead?.email}
                              </span>
                            </div>
                            <div className="flex items-center justify-between gap-5 w-full">
                              <span className="text-sm font-bold leading-[160%] text-[#485868] inline-block">
                                Requested By:
                                <br />
                                <strong className="text-primary font-medium">
                                  {creditData?.requester?.first_name}{" "}
                                  {creditData?.requester?.last_name}
                                </strong>
                              </span>
                              <span className="text-sm font-bold leading-[160%] text-[#485868] inline-block">
                                Reviewer:
                                <br />
                                <strong className="text-customGray">
                                  {creditData?.reviewer?.first_name}
                                </strong>
                              </span>
                              <span className="text-sm font-bold leading-[160%] text-[#485868] inline-block">
                                Lead ID:
                                <br />
                                <strong className="text-customGray">
                                  {creditData?.reviewedMatch?.lead?.id}
                                </strong>
                              </span>
                            </div>
                          </div>
                          <div className="pb-[14px] mb-[14px] border-b border-[#EBEFF3]">
                            <span className="text-sm font-bold leading-[160%] text-[#485868] inline-block mb-1">
                              Professional's Comment:
                            </span>
                            <p className="text-sm font-normal leading-[160%] text-[#485868]">
                              {creditData?.reason}
                            </p>
                          </div>
                          <div className="pb-[14px] mb-[14px] border-b border-[#EBEFF3]">
                            <span className="text-sm font-bold leading-[160%] text-[#485868] inline-block mb-1">
                              Decision Comment:
                            </span>
                            <p className="text-sm font-normal leading-[160%] text-[#485868]">
                              {creditData?.decision}
                            </p>
                          </div>
                          <div className="mb-4">
                            <div className="flex items-center justify-between gap-2 mb-[10px]">
                              <h6 className="text-base font-bold leading-[160%] text-customGray">
                                Credit Request:
                              </h6>
                              <h6 className="text-base font-bold leading-[160%] text-customGray mb-1">
                                {creditData?.credit_cost ?? 0} Credits
                              </h6>
                            </div>
                            {/* <p className="text-sm font-normal leading-[140%] text-customGray">
                              Respond By Date: {creditData.respond_date}
                            </p> */}
                          </div>
                          <div className="grid grid-cols-1 gap-6">
                            {/* <Button
                              title="SEE DETAILS"
                              classes="text-sm font-black leading-[160%] text-primary h-10 rounded-[10px] flex items-center justify-center bg-transparent border border-primary uppercase"
                              onClick={() => setShowAdminActiveCreditSlideOver(true)}
                            /> */}
                          </div>
                        </div>
                      </div>
                      {/* data section end */}
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default AdminActiveCreditSlideOver;
